var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./BubbleTrigger.module.scss";
import { getSettings } from "../../constants/setting";
import PromptMessageBubble from "../PromptMessageBubble/PromptMessageBubble";
import { useSelector } from "react-redux";
import { hasAlreadyInteractedWithChatBot } from "../../stores/reducers/chatReducer";
import { CHAT_BOT_POSITION_LEFT } from "../../constants";
var BubbleTrigger = function (props) {
    var hasInteractedAlready = useSelector(hasAlreadyInteractedWithChatBot);
    var onClickCallback = props.onClickCallback;
    var _b = getSettings(), trigger_icon = _b.trigger_icon, icon_background_color = _b.icon_background_color, icon_bottom_offset = _b.icon_bottom_offset, icon_side_offset = _b.icon_side_offset, chat_bot_position = _b.chat_bot_position, icon_size = _b.icon_size, new_user_prompt_hide_on_mobile = _b.new_user_prompt_hide_on_mobile;
    return _jsxs("div", __assign({ className: styles.bubble, style: {
            backgroundColor: icon_background_color || '#ffffff',
            bottom: icon_bottom_offset || '0px',
            right: chat_bot_position === CHAT_BOT_POSITION_LEFT ? 'auto' : (icon_side_offset + 'px'),
            left: chat_bot_position === CHAT_BOT_POSITION_LEFT ? (icon_side_offset + 'px') : 'auto',
        } }, { children: [!hasInteractedAlready && _jsx("div", __assign({ className: "".concat(styles.bubbleLabel, " ").concat(new_user_prompt_hide_on_mobile ? styles.hideOnMobile : '') }, { children: _jsx(PromptMessageBubble, { onClickCallback: onClickCallback }) })), _jsx("div", __assign({ className: styles.ImageIconWrapper }, { children: _jsx("button", __assign({}, { tabIndex: 0 }, { onClick: function () { return onClickCallback(); } }, { children: _jsx("img", { className: styles.imageIcon, src: trigger_icon, style: {
                            width: (icon_size || 30) + 'px',
                            height: (icon_size || 30) + 'px'
                        }, crossOrigin: "anonymous", alt: "Open AlwaysOn Chatbot" }) })) }))] }));
};
export default BubbleTrigger;
